<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">

    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>

    <div class="currentlocation">
      <div class="location">
        <p [innerHTML]="getLocationText()"></p>
      </div>
      <ng-container *ngIf="distance != null">
        <div class="distance">
          <p [innerHTML]="getDistanceText()"></p>
        </div>
      </ng-container>
    </div>
    <div class="addressOverview">
      <div class="label">
        <h3 langkey="phMenuChangeLocationDialog_Address"></h3>
      </div>
      <div class="street">{{menuChangeLocationViewModel.street}}</div>
      <div class="ziplocation">{{menuChangeLocationViewModel.zip}}, {{menuChangeLocationViewModel.location}}</div>
    </div>
    <div class="opentimes">
      <div class="label">
        <h3 [langkey]="serviceOpenTimeTitle"></h3>
      </div>
      <div class="times">
        <div class="location-openday">
          <ng-container *ngFor="let openday of menuChangeLocationViewModel.openDays; let first = first">
            <div class="weekday" [class.highlight]="first">{{openday.weekdayToString()}}:</div>
            <p [class.highlight]="first">{{openday.timesToString()}}</p>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="buttonscontainer">
      <ng-container *ngIf="!data.hasOneLocation">
        <div class="ya-button-container">
          <button mat-flat-button (click)="onChangeLocation()">
            <span langkey="phMenuChangeLocationDialog_ChangeLocation"></span>
          </button>
        </div>
      </ng-container>
      <div class="ya-button-container">
        <button mat-flat-button (click)="onChangeService()">
          <span langkey="phMenuChangeLocationDialog_ChangeService"></span>
        </button>
      </div>
    </div>
  </div>
</div>